/* eslint-disable import/prefer-default-export */
export enum ClientConfigTypes {
  syft_url = 'Syft Url',
}

// name used for storying custom tabs for the clients
export const CUSTOM_TABS_OPTIONS = 'custom_tab_options';
